export default "__VITE_ASSET__DHv2Nyor__"